(() => {
  const KEYWORDS = [
    "shirt","shirts","hoodie","hoodies","tee","tees","t-shirt","t shirt",
    "crewneck","sweatshirt","apparel","clothing","merch","swag",
    "long sleeve","long sleeve tee","mug","travel","travel mug",
    "phone","phone case","drawstring","tote","coaster",
    "socks","hat","beanie","tumbler","kids"
  ];

  function shouldRedirect(q) {
    if (!q) return false;
    const s = q.toLowerCase();
    return KEYWORDS.some(k => s.includes(k));
  }

  function redirectToSwag(q) {
    window.location.href = `https://www.chubblegumswag.com/search?q=${encodeURIComponent(q)}`;
  }

  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    // Only act on GET search forms that have a q input
    const method = (form.getAttribute("method") || "get").toLowerCase();
    if (method !== "get") return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const q = (input.value || "").trim();
    if (!shouldRedirect(q)) return;

    e.preventDefault();
    redirectToSwag(q);
  });
})();
